const billedStatus = `data?.status == 'BILLED'`;
const closedStatus = `data?.status == 'CLOSED'`;
const inProcessStatus = `data?.status == 'IN_PROCESS'`;
const inProductionStatus = `data?.status == 'IN_PRODUCTION'`;
const processedStatus = `data?.status == 'PROCESSED'`;
const conceptStatus = `data?.status == 'CONCEPT'`;
const openStatus = `data?.status == 'OPEN'`;
const completelyDeliveredStatus = "data?.weight == data?.deliveredWeight";
const partiallyDeliveredStatus = "data?.deliveredWeight > 0";
const blockedStatus = "data?.status == 'BLOCKED'";
const enRouteStatus = `data?.status == 'EN_ROUTE'`;
const inProgressStatus = `data?.status == 'EXPECTED'`;
const syncingStatus = `data?.status == "SYNCING_WITH_ACCOUNTING_SOFTWARE"`;
const syncFailedStatus = `data?.status == "SYNCING_FAILED"`;
const syncedStatus = `data?.status == "SYNCED"`;
const usedStatus = "data?.status == 'USED'";
const reservedStatus = "data?.status == 'RESERVED'";
const partiallyReservedStatus = "data?.status == 'PARTIALLY_RESERVED'";
const confirmedStatus = "data?.status == 'BILLED'";

const billedColor = "bg-green-400";
const closedColor = "bg-green-200";
const inProcessColor = "bg-amber-400";
const inProductionColor = "bg-amber-200";
const conceptColor = "bg-stone-200";
const openColor = "bg-white";
const blockedColor = "bg-red-200";
const enRouteColor = "bg-orange-300";
const inProgressColor = "bg-amber-200";
const syncingColor = "bg-violet-300";
const syncedColor = "bg-blue-300";
const usedColor = "bg-blue-200";

function purchaseOrderStatusColor() {
	return {
		[blockedColor]: syncFailedStatus,
		[syncingColor]: syncingStatus,
		[syncedColor]: syncedStatus,
		[closedColor]: closedStatus,
		[inProcessColor]: inProcessStatus,
		[conceptColor]: conceptStatus,
		[openColor]: openStatus,
	};
}

function purchaseOrderRowStatusColor() {
	return {
		[billedColor]: billedStatus,
		[closedColor]: closedStatus,
		[inProcessColor]: inProcessStatus,
		[inProductionColor]: inProductionStatus,
		[conceptColor]: conceptStatus,
		[openColor]: openStatus,
	};
}

function salesOrderStatusColor() {
	return {
		[billedColor]: billedStatus,
		[closedColor]: closedStatus,
		[inProcessColor]: inProcessStatus,
		[inProductionColor]: inProductionStatus,
		[conceptColor]: conceptStatus,
		[openColor]: openStatus,
	};
}

function salesOrderRowStatusColor() {
	return {
		[billedColor]: billedStatus,
		[closedColor]: closedStatus,
		[inProcessColor]: inProcessStatus,
		[inProductionColor]: inProductionStatus,
		[conceptColor]: conceptStatus,
		[openColor]: openStatus,
	};
}

function productionStatusColor() {
	return {
		[blockedColor]: syncFailedStatus,
		[syncingColor]: syncingStatus,
		[syncedColor]: syncedStatus,
		[billedColor]: billedStatus,
		[closedColor]: closedStatus,
		[inProcessColor]: inProcessStatus,
		[inProductionColor]: inProductionStatus,
		[conceptColor]: conceptStatus,
		[openColor]: openStatus,
	};
}

function productionStepStatusColor() {
	return {
		[billedColor]: billedStatus,
		[closedColor]: closedStatus,
		[inProcessColor]: inProcessStatus,
		[inProductionColor]: inProductionStatus,
		[conceptColor]: conceptStatus,
		[openColor]: openStatus,
	};
}

function inboundStatusColor() {
	return {
		[closedColor]: completelyDeliveredStatus,
		[inProcessColor]: partiallyDeliveredStatus,
	};
}

function outboundStatusColor() {
	return {
		[closedColor]: completelyDeliveredStatus,
		[inProcessColor]: partiallyDeliveredStatus,
	};
}

function lotStatusColor() {
	return {
		[blockedColor]: blockedStatus,
		[usedColor]: usedStatus,
		[closedColor]: reservedStatus,
		[inProcessColor]: partiallyReservedStatus,
		[inProgressColor]: inProgressStatus,
		[enRouteColor]: enRouteStatus,
	};
}

function productionStepResultLotStatusColor() {
	const producedPackages = (data: any) =>
		(data?.resultLots ?? []).reduce((sum: number, lot: any) => sum + Number(lot?.packageQuantity ?? 0), 0);

	const isClosed = (data: any) => {
		if (data?.status == "CLOSED") return true;
		const target = Number(data?.packageQuantity ?? 0);
		return target > 0 && producedPackages(data) >= target;
	};

	return {
		[closedColor]: (params: { data?: any }) => isClosed(params.data),
		[inProductionColor]: (params: { data?: any }) =>
			!isClosed(params.data) &&
			(params.data?.status == "OPEN" ||
				params.data?.salesOrderRow?.status == "IN_PRODUCTION" ||
				producedPackages(params.data) > 0),
	};
}

function reservationStatusColor() {
	return {
		[closedColor]: processedStatus,
		[openColor]: openStatus,
	};
}

function invoiceStatusColor() {
	return {
		[blockedColor]: syncFailedStatus,
		[syncingColor]: syncingStatus,
		[syncedColor]: syncedStatus,
		[closedColor]: confirmedStatus,
	};
}

export {
	purchaseOrderStatusColor,
	purchaseOrderRowStatusColor,
	salesOrderStatusColor,
	salesOrderRowStatusColor,
	productionStatusColor,
	productionStepStatusColor,
	inboundStatusColor,
	outboundStatusColor,
	lotStatusColor,
	productionStepResultLotStatusColor,
	reservationStatusColor,
	invoiceStatusColor,
};
